'use client';

import React from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

function AppLogo({
  src = '/assets/images/ChatGPT_Image_Jul_12__2026_at_10_18_16_PM-1783966036180.jpeg',
  text,
  iconName = 'SparklesIcon',
  size = 40,
  className = '',
  onClick,
}: AppLogoProps) {
  return (
    <div
      className={`flex items-center gap-2 ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      {src ? (
        <AppImage
          src={src}
          alt="Form Finish Auto Care logo"
          width={size}
          height={size}
          className="flex-shrink-0 rounded-full object-cover"
          style={{ width: size, height: size }}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}

      {text && <span className="text-xl font-bold">{text}</span>}
    </div>
  );
}

export default AppLogo;
